module.exports = __webpack_public_path__ + "static/img/person_3.f1f107e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person/person_3.jpg
// module id = kAsP
// module chunks = 1